export enum ServiceRideOrderStatus {
  'RideOrderStatusProcessing' = 'processing',
  'RideOrderStatusDone' = 'done',
  'RideOrderStatusDriverAccepted' = 'driver_accepted',
  'RideOrderStatusCanceled' = 'canceled',
}